import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: "0.4px",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M18 6H6v12h12zM6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z",
		clipRule: "evenodd"
	})
});
export default SvgStop;
